import React, { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import RolesList from "./RolesList";

const Roles = () => {
  const breadcrumbItems = [
    { title: "Settings", link: "" },
    { title: "User Managment", link: "" },
    { title: "Roles", link: "/settings/user_management/roles" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
              <RolesList />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Roles;
